const POINT_LIFESPAN = 750;
const WIDTH = 10;
const SPACING = 2;

export class StarBreathingTrail extends Phaser.GameObjects.Graphics {
  constructor(scene, x, y) {
    super(scene, x, y);
    this.setPosition(x, y);
    scene.add.existing(this);
    this._trailPoints = [];
  }

  addPoints(from, to) {
    const angle = Phaser.Math.Angle.BetweenPoints(from, to);
    const dx = SPACING * Math.cos(angle);
    const dy = SPACING * Math.sin(angle);
    let distance = Phaser.Math.Distance.BetweenPoints(from, to);
    let i = 0;
    while (i < distance) {
      this._trailPoints.push({ x: from.x + dx * i, y: from.y + dy * i, time: 0 });
      i += SPACING;
    }
  }

  update(delta) {
    this.clear();
    for (let i = this._trailPoints.length - 1; i >= 0; i--) {
      const point = this._trailPoints[i];
      point.time += delta;
      if (point.time >= POINT_LIFESPAN) this._trailPoints.splice(i, 1);
      else {
        this.moveTo(point.x, point.y);
        const percent = 1 - point.time / POINT_LIFESPAN;
        this.fillStyle(0x0053a3, percent);
        this.fillCircle(point.x, point.y, WIDTH * percent);
      }
    }
  }
}
